import { render } from "./AppColoredName.vue?vue&type=template&id=61a871d1&scoped=true&ts=true"
import script from "./AppColoredName.vue?vue&type=script&lang=ts"
export * from "./AppColoredName.vue?vue&type=script&lang=ts"

import "./AppColoredName.vue?vue&type=style&index=0&id=61a871d1&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a871d1"]])

export default __exports__